import { createRouter, createWebHistory,createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { guest: true }
  },
  {
    path: '/activate',
    name: 'Activate',
    component: () => import('@/views/ActivatePackage.vue')
  },
  {
    path: '/records',
    name: 'Records',
    component: () => import('@/views/DownloadRecords.vue')
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('@/views/Profile.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// router.beforeEach((to, from, next) => {
//   const isLoggedIn = !!localStorage.getItem('isLoggedIn')
//   if (!to.meta.guest && !isLoggedIn && to.path !== '/login') {
//     next('/login')
//   } else if (to.meta.guest && isLoggedIn) {
//     next('/')
//   } else {
//     next()
//   }
// })

export default router
